import { CountryUtilType } from "UidispatcherApiModule";
const { CountryUtil }: { CountryUtil: CountryUtilType } =
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export default CountryUtil;
